
import { Component, Vue, Prop, Emit } from "vue-property-decorator"
import { Getter } from "vuex-class"
import vSelect from "vue-select"
import api from "@/services/api"
import { TenantFeatures } from "@/types/tenantFeatures"
import { ExternalUser } from "@/types/externalUser"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class AddExternalUser extends Vue {
	@Getter getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	creatingNewExternalUser = false

	private externalUsersList: ExternalUser[] = [];
	private newExternalUser: ExternalUser = {
		id: "",
		tenantId: "",
		name: "",
		email: "",
		isExternal: true
	};

	private addUser (value: ExternalUser) {
		this.$emit("input", value)
	}

	mounted () {
		if (!this.getIsFeatureEnabled(TenantFeatures.SearchForExternalUsers)) {
			this.creatingNewExternalUser = true
		}
	}

	public async fetchExternalOptions (search: string, loading: (isLoading: boolean) => void) {
		if (search === "") {
			this.externalUsersList = []
		} else {
			loading(true)

			try {
				this.externalUsersList = await api.searchExternalUsers(search)
			} finally {
				loading(false)
			}
		}
	}
}
